import React from "react";
import "./AdvancedCare.css";

const AdvancedCare = () => {
  return (
    <section>
      <div className="hero-section">
        <div className="overlay"></div>
        <div className="text-container">
          <h1 className="fw-bold">
            How RemeCure Silicon Sheets Work for Scar Reduction
          </h1>
          <p className="lead">
            RemeCure Scar silicon sheets are the gold standard in scar
            management. Clinically proven to regulate moisture and reduce
            excessive collagen formation—one of the main causes of raised scars,
            they help flatten and fade raised, discolored scars. By acting as an
            occlusive barrier, RemeCure reduces water loss, creating an optimal
            healing environment. This not only smooths scars but also relieves
            itching and discomfort. Ideal for preventing hypertrophic scars and
            keloids, RemeCure is perfect for individuals prone to severe
            scarring after surgery or injury.
          </p>
          <button>Discover Products</button>
        </div>
      </div>
    </section>
  );
};

export default AdvancedCare;
